import Breakpoint from '../helpers/breakpoint';

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
const MainNav = (() => {
  const DOM = {};
  const transitionBreakpoint = "md";

  const cacheDOM = () => {
    DOM.hamburger = document.getElementsByClassName("toggleNav");
    DOM.toggleNav = document.getElementsByClassName("nav");
    DOM.menuItems = document.querySelectorAll(".menu-item > a");
    DOM.header = document.getElementsByClassName("header");
    DOM.menuClick = document.getElementsByClassName("menu-link");
  };

  const toggleNav = () => {
    const menu = DOM.toggleNav[0];
    const hamburger = DOM.hamburger[0];
    const header = DOM.header[0];
    const menuClick = DOM.menuClick[0];

    if (!hamburger.classList.contains("open")) {
      hamburger.classList.add("open");
      menu.classList.add("active");
      header.classList.add("fixed");
      menuClick.classList.add("active");
    } else {
      hamburger.classList.remove("open");
      menu.classList.remove("active");
      header.classList.remove("fixed");
      menuClick.classList.remove("active");
    }
  };


  const eventListeners = () => {
    let addMobileNavEventListeners = () => {
      DOM.hamburger[0].addEventListener("click", toggleNav);
      DOM.menuClick[0].addEventListener("click", toggleNav);
      Array.from(DOM.menuItems).forEach((HTMLNode) => {
        HTMLNode.addEventListener("click", toggleNav);
      });
    }

    if (Breakpoint.isBreakpointDown(transitionBreakpoint)) {
      addMobileNavEventListeners();
    }

    window.addEventListener('resize', function () {
      if (Breakpoint.isBreakpointDown(transitionBreakpoint)) {
        addMobileNavEventListeners();
      } else {
        DOM.hamburger[0].removeEventListener("click", toggleNav);
        DOM.menuClick[0].removeEventListener("click", toggleNav);
        Array.from(DOM.menuItems).forEach((HTMLNode) => {
          HTMLNode.removeEventListener("click", toggleNav);
        });
      }
    }, false);
  };

  const init = () => {
    cacheDOM();
    eventListeners();
  };

  return {
    init,
  };
})();

export default MainNav;
